export default __webpack_public_path__ + "static/media/tunisianrecipes.0283c97f.jpg";